import { render, staticRenderFns } from "./searchlibrary.html?vue&type=template&id=3882aeb5&scoped=true&"
import script from "./searchlibrary.js?vue&type=script&lang=js&"
export * from "./searchlibrary.js?vue&type=script&lang=js&"
import style0 from "./searchlibrary.sass?vue&type=style&index=0&id=3882aeb5&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3882aeb5",
  null
  
)

component.options.__file = "searchlibrary.vue"
export default component.exports